import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  banner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
    paddingRight: theme.spacing(6),
    marginBottom: theme.spacing(3),
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    borderRadius: 12,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(2),
      paddingRight: theme.spacing(6),
    },
  },
  icon: {
    display: 'flex',
    color: '#00205B',
    fontSize: 32,
    flexShrink: 0,
  },
  copy: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
    marginBottom: theme.spacing(0.75),
  },
  caption: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: '#172024',
  },
  ctaButton: {
    borderRadius: 20,
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1.25, 3.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
  },
  dismissButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: '#3D4A51',
  },
}))

export default useStyles
